const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid'];

export function captureUtms() {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    const found = {};
    UTM_KEYS.forEach((k) => {
        const v = params.get(k);
        if (v) found[k] = v;
    });
    if (Object.keys(found).length > 0) {
        try {
            sessionStorage.setItem('iinspire_utm', JSON.stringify(found));
        } catch (e) { /* storage unavailable */ }
    }
}

export function getUtms() {
    try {
        return JSON.parse(sessionStorage.getItem('iinspire_utm') || '{}');
    } catch (e) {
        return {};
    }
}

export function track(event, params = {}) {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params, ...getUtms() });
    if (typeof window.gtag === 'function') {
        window.gtag('event', event, params);
    }
    try {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ event, page: window.location.pathname, ...params, ...getUtms() }),
            keepalive: true,
        }).catch(() => {});
    } catch (e) { /* beacon unavailable */ }
    if (process.env.NODE_ENV === 'development') {
        console.debug('[track]', event, params);
    }
}
